import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import ParkingServices from "services/ParkingServices";
import { notifyError, notifySuccess } from "utils/toast";
import { collapseCosts, categoryMap, expandCosts } from "utils/parkingCost";

const useParkingSubmit = (id , vehicleUrl , setVehicleUrl) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [existingImage, setExistingImage] = useState('');
  
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    clearErrors,

    formState: { errors },
  } = useForm();

  // Handle Add/Edit Submit
  // console.log(onSubmit)
  //   console.log(onSubmit)
  const onSubmit = async (data, categories) => {
    setLoading(true);
    setIsSubmitting(true);
//console.log(data)
    try {
      const backendCosts = {};

      categories.forEach((group) => {
        const value = Number(data.costs?.[group.groupName]) || 0;
        backendCosts[group.groupName] = value;
      });
      // console.log("cost---", backendCosts);
     // Image optional — if not uploaded, leave blank
// const finalImage = vehicleUrl || existingImage || "";

      if(vehicleUrl){
    const partsLogo = vehicleUrl.split("/");
      const filename_logo=partsLogo[partsLogo.length - 2]+'/'+partsLogo[partsLogo.length - 1];
      setVehicleUrl(filename_logo);
   }
      const parkingData = {
        city_id: selectedCity || null,
        sight_seeing: data.sight_seeing,
        cost: backendCosts,
        image: vehicleUrl || existingImage,
        timing: data.timing || null,
        entry: data.entry || null,
      };
  // console.log("Final Parking Data:", data);
  //    console.log("Final Parking Data:", parkingData);
let res;
  if (id) {
  res = await ParkingServices.updateParking(id, parkingData);
} else {
  res = await ParkingServices.addParking(parkingData);
}

// Check for custom backend error
if (res?.status === false) {
  notifyError(res.message || "Something went wrong. Please try again.");
  return; // stop execution if backend says it's an error
}

// Success
setIsUpdate(true);
notifySuccess(id ? "Updated successfully!" : "Added successfully!");
closeDrawer();
     
    } catch (err) {
notifyError(
  err?.response?.data?.message ||
  err?.message ||
  "Something went wrong. Please try again."
);

    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  // Get existing Parking Data by ID
  const getParkingData = async (id) => {
    try {
      const res = await ParkingServices.getParkingById(id);
      // console.log("data in input field", res);

      if (res) {
        setValue("city", res.city_name.name);
        setValue("sight_seeing", res.sight_seeing);
        setSelectedCity(res.city_name.id);
// console.log(res,"--------res")
        const costs = res.costs || {};
        setValue("costs.Sedan", costs["Sedan"] ?? "");
        setValue("costs.Suv & Muv", costs["Suv & Muv"] ?? "");
        setValue("costs.Tempo Traveller", costs["Tempo Traveller"] ?? "");
        setExistingImage(res.image);
        setVehicleUrl(res.image);
        setValue("timing", res.timimg || "");
        setValue("entry", res.entry || "");

      }
    } catch (err) {
      notifyError(err?.response?.data?.message || err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
      setSelectedCity(null);
      setValue("costs.Sedan", "");
      setValue("costs.Suv & Muv", "");
      setValue("costs.Tempo Traveller", "");
      setExistingImage("");
      setVehicleUrl("");
      setValue("timing", "");
      setValue("entry", "");
      clearErrors();
      reset();
      return;
    }

    // If editing, fetch parking data by parking ID
    if (id) {
      const fetchParking = async () => {
        try {
          const data = await ParkingServices.getParkingById(id);
          if (data) {
         
            setSelectedCity(data.city_name.id);
            setValue("city", data.city_name.id);
            setValue("sight_seeing", data.sight_seeing);

            // Fill costs dynamically
            const costs = data.costs || {};

            setValue("costs.Sedan", costs["Sedan"] ?? "");
            setValue("costs.Suv & Muv", costs["Suv & Muv"] ?? "");
            setValue("costs.Tempo Traveller", costs["Tempo Traveller"] ?? "");
            setExistingImage(data.image);
            setVehicleUrl(data.image);
            setValue("timing", data.timing || "");
            setValue("entry", data.entry || "");
          }
        } catch (err) {
          console.error("Error fetching parking data:", err);
        }
      };

      fetchParking();
    }
    // eslint-disable-next-line
  }, [id, isDrawerOpen, setValue, clearErrors, reset, setSelectedCity]);

  return {
    register,
    handleSubmit,
    onSubmit,
    loading,
    setLoading,
    errors,
    isSubmitting,
    selectedCity,
    setSelectedCity,
    existingImage,
    setExistingImage,
  };
};

export default useParkingSubmit;
